import React, {FC, useEffect} from 'react';
import {useAppSelector} from 'redux/hooks';

import {t} from 'i18next';
import {
  addNewOrderUpd,
} from "../../../redux/orders/reducer";
import {Button, Input} from "../../commons";
import {withFormik} from "formik";
import Validations from "./Validations";
import store from "../../../redux/store";
import FileInput from "../../commons/Input/FileInput";
import ordersService from "../../../api/services/ordersService";

interface OrderFormFields {
  orderId: number | null
  number: string | null
  amount: string | null
  date: string | null
  xmlString: string|null
  file: object | null
}

interface OrderFormProps {
  values: OrderFormFields,
  touched: any,
  errors: any,
  isSubmitting: any,
  handleChange: any,
  handleBlur: any,
  handleSubmit: any,
  resetForm: any,
  setValues: any,
  setFieldValue: any,
  isNeedClearForm: boolean,
  toCloseUpdForm: () => void,
}

const initialFields: OrderFormFields = {
  orderId: null,
  number: null,
  amount: null,
  date: null,
  xmlString: null,
  file: null,
}

const InnerFormOrder: FC<OrderFormProps> = ({
  values,
  touched,
  errors,
  isSubmitting,
  handleChange,
  handleBlur,
  handleSubmit,
  resetForm,
  setFieldValue,
  isNeedClearForm,
  toCloseUpdForm
}) => {

  const editingRow = useAppSelector((state) => state.orders);
  //const currentSeller = useAppSelector((state) => state.sellers.currentSeller);
  // @ts-ignore
  //values.sellerID = currentSeller.info.data.id
  values.orderId = editingRow.currentOrderId ? parseInt(editingRow.currentOrderId) : null

  async function readSingleFile(e: any) {
    const file = e.target.files[0];
    if (!file) {
      setFieldValue('xmlString', null);
      return;
    }
    const t = await preReadFile(file)
    console.log(t)


    const encoding = 'windows-1251';

    console.log('encoding: ', encoding)

    const reader = new FileReader();
    reader.onload = function(e :any) {
      let content = e.target.result;
      content = content.replace('windows-1251', 'utf-8');
      setFieldValue('xmlString', window.btoa(unescape(encodeURIComponent(content))));

      ordersService.validateUpdToOrder(window.btoa(unescape(encodeURIComponent(content)))).then(
          (res) => {
            if (res.data.success) {
              const resData = res.data.data

              const dt = new Date(resData[2].date);
              setFieldValue('number', resData[0]);
              setFieldValue('amount', resData[1]);
              setFieldValue('date', dt.toISOString().slice(0, -8));

              // console.log(resData[2].date);
            }
          },
          (err) => {
            alert('Failed getting order upds: ' + err.message)
          }
      ).catch(
          (err) => {
            console.log(err.message);
          }
      )
    };

    reader.readAsText(file, encoding);

    return reader.onload;
  }


  async function preReadFile(file: any)
  {
    const preReader = new FileReader();
    await preReader.readAsText(file);
    preReader.onload = await function(e :any) {
      return e.target.result;
    };
    return preReader;
  }

  useEffect(() => {
    if (!editingRow) {
      resetForm()
      return;
    }

    console.log(editingRow);

  }, [editingRow])

  useEffect(() => {
    if (isNeedClearForm) {
      resetForm()
      console.log('resetForm')
    }
  }, [isNeedClearForm]);

  function abortBtnHandler () {
    toCloseUpdForm()
    resetForm()
  }

  function submitHandler(event: any) {
    event.preventDefault()
    handleSubmit(event);
    toCloseUpdForm();
  }

  const customInputClassName = 'border-[#E2E8F0] rounded-md shadow-sm placeholder-slate-400  w-full focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500 disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none'
  return (
      // @ts-ignore
      <form onSubmit={submitHandler} className="w-full bg-[#F1F5F9] p-3 mt-4">
        {/*{JSON.stringify(values)}*/}
        <div>
          <div style={{overflowWrap: 'anywhere'}}>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="mb-2">
              <Input
                  placeholder=""
                  id="number"
                  name="number"
                  value={values.number ?? ''}
                  label={t<string>("Номер", { ns: "messages" })}
                  changeHandler={handleChange}
                  customClassName={customInputClassName}
                  customLabelClassName="text-sm"
                  blurHandler={handleBlur}
                  validationError={touched.number && errors && errors.number && errors.number.length > 0}
                  validationErrorDescription={touched.number ? errors.number : ''}
              />
            </div>

            <div className="mb-2">
              <Input
                  placeholder="100"
                  id="amount"
                  name="amount"
                  value={(values.amount && !isNaN(Number(values.amount))) ? values.amount : ''}
                  label={t<string>("Сумма", { ns: "messages" })}
                  changeHandler={handleChange}
                  customClassName={customInputClassName}
                  customLabelClassName="text-sm"
                  blurHandler={handleBlur}
                  validationError={touched.amount && errors && errors.amount && errors.amount.length > 0}
                  validationErrorDescription={touched.amount ? errors.amount : ''}
              />
            </div>

            <div className="mb-2">
              <Input
                  placeholder="100"
                  id="date"
                  name="date"
                  value={values.date ?? ''}
                  label={t<string>("Дата", { ns: "messages" })}
                  changeHandler={handleChange}
                  customClassName={customInputClassName}
                  customLabelClassName="text-sm"
                  type="datetime-local"
                  blurHandler={handleBlur}
                  validationError={touched.date && errors && errors.date && errors.date.length > 0}
                  validationErrorDescription={touched.date ? errors.date : ''}
              />
            </div>


            <div className="mb-2">
              <FileInput
                  id="file"
                  name="file"
                  label={t<string>("Файл", { ns: "messages" })}
                  changeHandler={readSingleFile}
                  customClassName={customInputClassName}
                  customLabelClassName="text-sm"
                  blurHandler={readSingleFile}
                  validationError={touched.file && errors && errors.file && errors.file.length > 0}
                  validationErrorDescription={touched.file ? errors.file : ''}
                  require={false}
              />
            </div>
          </div>
        </div>

        <div className="mt-4 flex justify-end">
          <Button
              appearance="tertiary"
              customClassName="btn-sm bg-white"
              loading={isSubmitting}
              clickHandler={abortBtnHandler}
          >
            {t<string>("abort", { ns: "messages" })}
          </Button>
          <Button
              type="submit"
              appearance="primary"
              customClassName="ml-2 btn-sm"
              loading={isSubmitting}
          >
            {t<string>("save", { ns: "messages" })}
          </Button>
        </div>
      </form>
  );
};



//@ts-ignore
const FormOrderUpd = withFormik({
  enableReinitialize: true,

  mapPropsToValues: () => (initialFields),

  validate: (values: OrderFormFields) => {
    let errors = {};

    console.log('Validation', values)

    const validation = Validations();

    //@ts-ignore
    Object.keys(values).forEach((key) => validation[key] && validation[key](errors, values[key]))

    return errors;
  },

  handleSubmit: (values: OrderFormFields, { setSubmitting, resetForm }) => {
    setSubmitting(true);
    setTimeout(() => {
      console.log('Submission', values);

      console.log(values.xmlString)
      //@ts-ignore<
      store.dispatch(addNewOrderUpd(values))
      setSubmitting(false);
      resetForm();
    }, 500)
  },
  //@ts-ignore
})(InnerFormOrder)

export default FormOrderUpd;